<template>
  <form ref="form" @submit.prevent="handleSubmit">
    <component :is="stepComponent"
               :measurement="measurement"
               :endpoint="endpoint"
               @back="back"
               @save="saveStep"
							 @restart="step=1; measurement = {}"
               @reset="measurement = {}; saveStepToLocalStorage(null);"
               @skip="step++"
    />
  </form>
</template>

<script>
import FormStep1 from "./FormStep1.vue";
import FormStep2 from "./FormStep2.vue";
import FormStep3 from "./FormStep3.vue";
import FormStep4 from "./FormStep4.vue";
import FormStep5 from "./FormStep5.vue";
import FormStep6 from "./FormStep6.vue";
import FormStep7 from "./FormStep7.vue";
import FormStep8 from "./FormStep8.vue";
import FormStep9 from "./FormStep9.vue";
import axios from "axios";
import FormStepSend from "./FormStepSend.vue";

export default {
  name: "Form",
  components: {
    FormStep1,
    FormStep2,
    FormStep3,
    FormStep4,
    FormStep5,
    FormStep6,
    FormStep7,
    FormStep8,
    FormStep9,
    FormStepSend
  },
	props: {
		endpoint: {},
		existingMeasurement: {
		  type: Object,
			default: null,
		},
	},
  data(){
    return {
      step: 1,
      measurement: {},
    }
  },
  computed: {
    stepComponent(){
      const key = `FormStep${this.step}`;
      if(this.$options.components[key]){
        return key;
      }
      return 'FormStepSend';
    },
  },
  created() {
    if (this.existingMeasurement?.uuid) {
      this.measurement = this.existingMeasurement;
    } else {
      this.load();
    }
  },
	methods: {

    handleSubmit(){
      console.log('handleSubmit');

      const formData = new FormData(this.$refs.form);

      for (let [key, value] of formData) {
        console.log({key, value});
        this.measurement[key] = value;
      }

			this.save();

      this.next();
    },
    back(){
      this.step--;
      window.scrollTo(0,0);
    },
    next(){
      this.step++;
      window.scrollTo(0,0);
    },
    saveStep(data){
      for(const key in data){
        this.measurement[key] = data[key];
      }
      this.save();
      this.next();
    },
		save(){
			window.localStorage.setItem('measurement', JSON.stringify(this.measurement));
      // console.log('saved', localStorage.getItem('measurement'));
		},
		load(){
			console.log('load');
			const existing = JSON.parse(window.localStorage.getItem('measurement'));
			if(existing){
				this.measurement = existing;
			}

			const existingStep = parseInt(window.localStorage.getItem('step'));
			if(existingStep){
				this.step = existingStep;
			}
		},
    saveStepToLocalStorage(step){
      window.localStorage.setItem('step', step);

    },
  },
	watch: {
		measurement(){
			console.log('watch triggered');
			this.save();
		},
		step(val){
      console.log('step watcher',val);
      this.saveStepToLocalStorage(val);
		}
	}
}
</script>
